import { coreCall } from '../../services/gatewayService';
import type { Message } from './types';

/**
 * Testo dei vocali di gruppo salvati sul numero di un collega (03/11/2026).
 *
 * In un gruppo con piu' numeri della stessa org il vocale si salva una volta sola, sul primo numero
 * che lo riceve: chi apre il gruppo dal proprio numero vede il vocale dal telefono ma non trova il
 * testo tra i suoi messaggi. Il core lo ritrova per gruppo e chiave (POST whatsapp/group-transcriptions).
 * Se la chiamata fallisce i messaggi restano come sono.
 */

const AUDIO = new Set(['audio', 'ptt', 'voice']);
const CHUNK = 60;

export function audioIdsWithoutText(messages: Message[]): string[] {
  return messages.filter((m) => AUDIO.has(m.type) && !m.transcription && typeof m.id === 'string').map((m) => m.id);
}

export function applyTranscriptions(messages: Message[], texts: Record<string, string>): Message[] {
  if (Object.keys(texts).length === 0) return messages;
  return messages.map((m) => (texts[m.id] && !m.transcription ? { ...m, transcription: texts[m.id] } : m));
}

export async function fetchGroupTranscriptions(messages: Message[], configId: string, chatId: string): Promise<Record<string, string>> {
  const texts: Record<string, string> = {};
  if (!chatId.endsWith('@g.us')) return texts;
  const ids = audioIdsWithoutText(messages);
  for (let i = 0; i < ids.length; i += CHUNK) {
    const { data, error } = await coreCall<{ transcriptions?: Record<string, string> }>('whatsapp/group-transcriptions', {
      body: { configId, chatId, messageIds: ids.slice(i, i + CHUNK) },
    });
    if (error || !data?.transcriptions) break;
    Object.assign(texts, data.transcriptions);
  }
  return texts;
}
